<template>
  <v-card style="overflow: visible;" class="elevation-0">
    <v-toolbar flat color="white" density="compact">
      <v-btn-toggle v-model="advanced_search.status" class="ml-5" density="compact" mandatory base-color="white" color="primary" rounded="xl" border @update:model-value="showRecords">
        <v-btn value="open">
          {{ $store.getters.translate('open') }}
        </v-btn>
        <v-btn value="closed">
          {{ $store.getters.translate('closed') }}
        </v-btn>
        <v-btn value="all">
          {{ $store.getters.translate('all') }}
        </v-btn>
      </v-btn-toggle>
      <v-autocomplete
          class="reg-normal text-primary ml-5"
          base-color="border-tertiary"
          bg-color="secondary"
          density="compact"
          v-model="advanced_search.priority"
          :items="['Prior 0','Prior 1','Prior 2','Prior 3']"
          @update:model-value="showRecords"
          hide-details
          single-line
          clearable>
        <template #label>
          <span class="sm-normal text-subtle">{{ $store.getters.translate('priority') }}</span>
        </template>
      </v-autocomplete>
      <v-autocomplete
          class="reg-normal text-primary ml-5"
          base-color="border-tertiary"
          bg-color="secondary"
          density="compact"
          v-model="advanced_search.company_priority"
          :items="['Critical','High','Medium','Low']"
          @update:model-value="showRecords"
          hide-details
          single-line
          clearable>
        <template #label>
          <span class="sm-normal text-subtle">{{ $store.getters.translate('company_priority') }}</span>
        </template>
      </v-autocomplete>
      <v-menu :close-on-content-click="false" location="bottom" transition="scale-transition">
        <template #activator="{ props }">
          <v-text-field
              v-bind="props"
              density="compact"
              class="reg-normal text-primary ml-5"
              base-color="border-tertiary"
              bg-color="secondary"
              color="primary"
              v-model="getStartDate"
              @click:clear="clearStartDate"
              readonly
              hide-details
              single-line
              flat
              clearable
              prepend-inner-icon="mdi-calendar">
            <template #label>
              <span class="sm-normal text-subtle">{{ $store.getters.translate('start_date') }}</span>
            </template>
          </v-text-field>
        </template>
        <v-date-picker v-model="advanced_search.start_date" color="primary" @update:model-value="showRecords"/>
      </v-menu>
      <v-spacer/>
    </v-toolbar>
    <v-card-text>
      <v-row class="mt-0">
        <v-col cols="auto">
          <v-chip color="success" variant="tonal">
            {{ articles_sorted_by_cup.length }} {{ $store.getters.translate('articles') }}
          </v-chip>
        </v-col>
        <v-col cols="auto">
          <v-chip color="error" variant="tonal">
            {{ sece_defects_count }} {{ $store.getters.translate('sece') }} {{ $store.getters.translate('defects') }}
          </v-chip>
        </v-col>
        <v-col cols="auto">
          <v-chip color="warning" variant="tonal">
            {{ non_sece_defects_count }} {{ $store.getters.translate('non_sece') }} {{ $store.getters.translate('defects') }}
          </v-chip>
        </v-col>
      </v-row>
      <Draggable
          ref="tree"
          class="mtl-tree ma-5"
          :defaultOpen="false"
          v-model="records"
          :disableDrag="true"
          :disableDrop="true"
          indent="20"
          treeLine>
        <template #default="{ node, stat }">
          <div style="display: flex; align-items: center; width: 100%;">
            <OpenIcon v-if="stat.children && stat.children.length" :open="stat.open" @click.native="onToggle(stat)"/>
            <template v-if="node.type === 'cluster' || node.type === 'unit' || node.type === 'platform'">
              <span class="text-primary ma-3" :class="stat.open ? 'sm-bold' : 'sm-normal'">
                {{ node.name }}
              </span>
              <v-chip @click="fillPlatformChildren(node, 'articles')" size="small" color="success" variant="tonal">
                {{ node.amount_of_equipment }} {{ $store.getters.translate('articles') }}
              </v-chip>
              <v-chip @click="fillPlatformChildren(node, 'sece_defects')" size="small" color="error" variant="tonal" class="ml-2">
                {{ node.amount_of_sece_defects }} {{ $store.getters.translate('sece') }} {{ $store.getters.translate('defects') }}
              </v-chip>
              <v-chip @click="fillPlatformChildren(node, 'non_sece_defects')" size="small" color="warning" variant="tonal" class="ml-2">
                {{ node.amount_of_non_sece_defects }} {{ $store.getters.translate('non_sece') }} {{ $store.getters.translate('defects') }}
              </v-chip>
<!--              <v-chip v-if="node.amount_of_equipment && (node.amount_of_sece_defects || node.amount_of_non_sece_defects)" size="small" color="primary" variant="tonal" class="ml-2">
                {{ $store.getters.translate('defect_rate') }}: {{ Math.round(((node.amount_of_sece_defects + node.amount_of_non_sece_defects)/node.amount_of_equipment)*100) }}%
              </v-chip>-->
              <v-chip v-if="node.amount_of_equipment && node.amount_of_sece_defective_equipment" size="small" color="primary" variant="tonal" class="ml-2">
                {{ $store.getters.translate('sece') }} {{ $store.getters.translate('defective_equipment_rate') }}: {{ Math.round((node.amount_of_sece_defective_equipment/node.amount_of_equipment)*100) }}%
              </v-chip>
              <v-chip v-else size="small" color="primary" variant="tonal" class="ml-2">
                {{ $store.getters.translate('sece') }} {{ $store.getters.translate('defective_equipment_rate') }}: 0%
              </v-chip>
              <v-chip v-if="node.amount_of_equipment && node.amount_of_non_sece_defective_equipment" size="small" color="primary" variant="tonal" class="ml-2">
                {{ $store.getters.translate('non_sece') }} {{ $store.getters.translate('defective_equipment_rate') }}: {{ Math.round((node.amount_of_non_sece_defective_equipment/node.amount_of_equipment)*100) }}%
              </v-chip>
              <v-chip v-else size="small" color="primary" variant="tonal" class="ml-2">
                {{ $store.getters.translate('non_sece') }} {{ $store.getters.translate('defective_equipment_rate') }}: 0%
              </v-chip>
            </template>
            <span v-else-if="node.type === 'chunk'" class="text-primary ma-3" :class="stat.open ? 'sm-bold' : 'sm-normal'">
              {{ node.name }}
            </span>
            <a v-else class="sm-normal text-primary ma-3" :href="node.name ? '/articles/' + node.id : '/defects/' + node.id" target="_blank">{{ node.name ? node.name : node.group_name + ', description: ' + node.deviations_and_remarks }}</a>
          </div>
        </template>
      </Draggable>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from "moment";
import { Draggable, OpenIcon } from '@he-tree/vue';
import '@he-tree/vue/style/default.css';
import helpFunctions from "../../plugins/helpFunctions";

export default {
  components: { Draggable, OpenIcon },
  data() {
    return {
      all_records: [],
      records: [],
      articles_sorted_by_cup: [], //cup = cluster, unit and platform
      advanced_search: {
        priority: null,
        company_priority: null,
        status: "all",
        start_date: null,
      },
      sece_defects_count: 0,
      non_sece_defects_count: 0,
      previousPlatformStat: null, // stat of the currently expanded platform
      clusters: [{
          name: "West",
          units: [{
              name: "1",
              platforms: [
                { id: 1, name: "D15-A" },
                { id: 8378, name: "K9-B" },
                { id: 9296, name: "K12-BP" },
                { id: 10003, name: "K2-A" },
                { id: 27402, name: "L7-F" },
                { id: 29658, name: "K12-BD" },
              ]
            }, {
              name: "2",
              platforms: [
                { id: 470, name: "L10-AR" },
                { id: 522, name: "L10-AD" },
                { id: 1828, name: "L10-F" },
                { id: 1959, name: "L10-E" },
                { id: 2120, name: "L10-B" },
                { id: 2225, name: "L10-L" },
                { id: 2460, name: "L10-AC" },
                { id: 2539, name: "L10-M" },
                { id: 2628, name: "L10-AP" },
                { id: 9667, name: "K12-G" },
                { id: 9850, name: "K12-K" },
                { id: 29643, name: "K12-D" },
              ]
            }],
        },
        {
          name: "East",
          units: [{
              name: "3",
              platforms: [
                { id: 10765, name: "G17-AP" },
                { id: 12010, name: "G16-A" },
                { id: 12058, name: "G14-A" },
                { id: 12244, name: "G16-B" },
                { id: 29981, name: "G17-AD" },
              ]
            }, {
              name: "4",
              platforms: [
                { id: 3247, name: "L15FA1" },
                { id: 3342, name: "L5-D" },
                { id: 7624, name: "L5FA1" },
                { id: 15305, name: "Q13-A" },
                { id: 20090, name: "F3FB1OLT" },
                { id: 20119, name: "F3B-P" },
                { id: 34396, name: "F3B-A" },
              ]
            }],
        }],
    };
  },
  methods: {
    async getArticlesSortedByClusterUnitAndPlatform() {
      if (this.articles_sorted_by_cup.length === 0) {
        this.articles_sorted_by_cup = await helpFunctions.getCustomRoute(this.$toast, 'articles-sorted-by-cluster-unit-and-platform', true);
      }
      this.showRecords();
    },
    showRecords() {
      let sorted_array = this.all_records;

      if(this.advanced_search.priority) {
        sorted_array = sorted_array.filter(item => item.priority === this.advanced_search.priority);
      }
      if(this.advanced_search.company_priority) {
        sorted_array = sorted_array.filter(item => item.company_priority === this.advanced_search.company_priority);
      }
      if(this.advanced_search.status === 'closed') {
        sorted_array = sorted_array.filter(item => item.closed);
      }
      else if(this.advanced_search.status === 'open') {
        sorted_array = sorted_array.filter(item => !item.closed);
      }
      if (this.advanced_search.start_date) {
        sorted_array = sorted_array.filter(item => moment(item.created_at) > moment(this.advanced_search.start_date));
      }

      let temp_records = [];

      this.clusters.forEach((cluster) => {
        temp_records[cluster.name] = { id: cluster.name, name: cluster.name, type: "cluster", amount_of_sece_defective_equipment: 0, amount_of_non_sece_defective_equipment: 0, children: [] };
        temp_records[cluster.name].amount_of_equipment = this.articles_sorted_by_cup.filter(item => item.cluster === cluster.name).length;
        temp_records[cluster.name].amount_of_sece_defects = sorted_array.filter(item => item.cluster === cluster.name && item.sece).length;
        temp_records[cluster.name].amount_of_non_sece_defects = sorted_array.filter(item => item.cluster === cluster.name && !item.sece).length;

        cluster.units.forEach((unit) => {
          temp_records[cluster.name].children[unit.name] = { id: unit.name, name: "Unit " + unit.name, type: "unit", cluster: cluster.name, amount_of_sece_defective_equipment: 0, amount_of_non_sece_defective_equipment: 0, children: [] };
          temp_records[cluster.name].children[unit.name].amount_of_equipment = this.articles_sorted_by_cup.filter(item => item.cluster === cluster.name && item.unit === unit.name).length;
          temp_records[cluster.name].children[unit.name].amount_of_sece_defects = sorted_array.filter(item => item.cluster === cluster.name && item.unit === unit.name && item.sece).length;
          temp_records[cluster.name].children[unit.name].amount_of_non_sece_defects = sorted_array.filter(item => item.cluster === cluster.name && item.unit === unit.name && !item.sece).length;

          unit.platforms.forEach((platform) => {
            temp_records[cluster.name].children[unit.name].children[platform.name] = { id: platform.name, name: platform.name, type: "platform", cluster: cluster.name, unit: unit.name, amount_of_sece_defective_equipment: 0, amount_of_non_sece_defective_equipment: 0, children: [] };
            temp_records[cluster.name].children[unit.name].children[platform.name].amount_of_equipment = this.articles_sorted_by_cup.filter(item => item.cluster === cluster.name && item.unit === unit.name && item.root_asset_name === platform.name).length;
            temp_records[cluster.name].children[unit.name].children[platform.name].amount_of_sece_defects = sorted_array.filter(item => item.cluster === cluster.name && item.unit === unit.name && item.root_asset_name === platform.name && item.sece).length;
            temp_records[cluster.name].children[unit.name].children[platform.name].amount_of_non_sece_defects = sorted_array.filter(item => item.cluster === cluster.name && item.unit === unit.name && item.root_asset_name === platform.name && !item.sece).length;

            temp_records[cluster.name].children[unit.name].children[platform.name].articles = this.articles_sorted_by_cup.filter(item => item.cluster === cluster.name && item.unit === unit.name && item.root_asset_name === platform.name);
            temp_records[cluster.name].children[unit.name].children[platform.name].sece_defects = sorted_array.filter(item => item.cluster === cluster.name && item.unit === unit.name && item.root_asset_name === platform.name && item.sece);
            temp_records[cluster.name].children[unit.name].children[platform.name].non_sece_defects = sorted_array.filter(item => item.cluster === cluster.name && item.unit === unit.name && item.root_asset_name === platform.name && !item.sece);
          });
        });
      });

      let cluster_level_sece_processed_articles = [];
      let unit_level_sece_processed_articles = [];
      let platform_level_sece_processed_articles = [];

      let cluster_level_non_sece_processed_articles = [];
      let unit_level_non_sece_processed_articles = [];
      let platform_level_non_sece_processed_articles = [];

      this.sece_defects_count = sorted_array.filter(item => item.cluster && item.unit && item.sece).length;
      this.non_sece_defects_count = sorted_array.filter(item => item.cluster && item.unit && !item.sece).length;

      for (let i = 0; i < sorted_array.length; i++) {
        if(sorted_array[i].cluster && sorted_array[i].unit) {
          if(sorted_array[i].sece && !cluster_level_sece_processed_articles.includes(sorted_array[i].article_id)) {
            cluster_level_sece_processed_articles.push(sorted_array[i].article_id);
            temp_records[sorted_array[i].cluster].amount_of_sece_defective_equipment++;
          }
          else if(!sorted_array[i].sece && !cluster_level_non_sece_processed_articles.includes(sorted_array[i].article_id)) {
            cluster_level_non_sece_processed_articles.push(sorted_array[i].article_id);
            temp_records[sorted_array[i].cluster].amount_of_non_sece_defective_equipment++;
          }

          if(sorted_array[i].sece && !unit_level_sece_processed_articles.includes(sorted_array[i].article_id)) {
            unit_level_sece_processed_articles.push(sorted_array[i].article_id);
            temp_records[sorted_array[i].cluster].children[sorted_array[i].unit].amount_of_sece_defective_equipment++;
          }
          else if(!sorted_array[i].sece && !unit_level_non_sece_processed_articles.includes(sorted_array[i].article_id)) {
            unit_level_non_sece_processed_articles.push(sorted_array[i].article_id);
            temp_records[sorted_array[i].cluster].children[sorted_array[i].unit].amount_of_non_sece_defective_equipment++;
          }

          if(sorted_array[i].sece && !platform_level_sece_processed_articles.includes(sorted_array[i].article_id)) {
            platform_level_sece_processed_articles.push(sorted_array[i].article_id);
            temp_records[sorted_array[i].cluster].children[sorted_array[i].unit].children[sorted_array[i].root_asset_name].amount_of_sece_defective_equipment++;
          }
          else if(!sorted_array[i].sece && !platform_level_non_sece_processed_articles.includes(sorted_array[i].article_id)) {
            platform_level_non_sece_processed_articles.push(sorted_array[i].article_id);
            temp_records[sorted_array[i].cluster].children[sorted_array[i].unit].children[sorted_array[i].root_asset_name].amount_of_non_sece_defective_equipment++;
          }
        }
      }

      this.records = Object.values(temp_records);

      for (let i = 0; i < this.records.length; i++) {
        this.records[i].children = Object.values(this.records[i].children);

        for (let x = 0; x < this.records[i].children.length; x++) {
          this.records[i].children[x].children = Object.values(this.records[i].children[x].children);
          this.records[i].children[x].children = this.$lodash.sortBy(this.records[i].children[x].children, "name");
        }
      }
    },
    onToggle(stat) {
      /*if (!stat.open && stat.data.type === 'chunk' && stat.parent) {
        stat.parent.children.forEach((child) => {
          if (child !== stat && child.data.type === 'chunk') {
            child.open = false;
          }
        });
      }*/
      stat.open = !stat.open;
    },
    fillPlatformChildren(node, data_type) {
      if(node.type === 'cluster') {
        if(data_type === 'articles') {
          this.$router.push('/articles?cluster=' + node.id);
        }
        else {
          this.$emit('showDefectsTable', {data_type: data_type, type: 'cluster', cluster: node.id});
        }
      }
      else if(node.type === 'unit') {
        if(data_type === 'articles') {
          this.$router.push('/articles?cluster=' + node.cluster + '&unit=' + node.id);
        }
        else {
          this.$emit('showDefectsTable', {data_type: data_type, type: 'unit', cluster: node.cluster, unit: node.id});
        }
      }
      else if(node.type === 'platform') {
        if(data_type === 'articles') {
          this.$router.push('/articles?cluster=' + node.cluster + '&unit=' + node.unit + '&root_asset_name=' + node.id);
        }
        else {
          this.$emit('showDefectsTable', {data_type: data_type, type: 'platform', cluster: node.cluster, unit: node.unit, root_asset_name: node.id});
        }
      }
      /*else if(node.type === 'platform') {
        let currentPlatformStat = this.$refs.tree.getStat(node);

        //CLOSE PREVIOUSLY OPENED PLATFORM AND CLEAN IT`S CHILDREN TO SAVE RAM
        if (this.previousPlatformStat && this.previousPlatformStat !== currentPlatformStat) {
          this.previousPlatformStat.open = false;
          if (this.previousPlatformStat.children && this.previousPlatformStat.children.length > 0) {
            this.$refs.tree.removeMulti([...this.previousPlatformStat.children]);
          }
        }

        //CLEAN CURRENT PLATFORM CHILDREN
        if (currentPlatformStat.children && currentPlatformStat.children.length > 0) {
          this.$refs.tree.removeMulti([...currentPlatformStat.children]);
        }

        this.previousPlatformStat = currentPlatformStat;

        if(node[data_type].length > 0) {
          let children = [];
          for (let i = 0; i <= Math.floor(node[data_type].length/500); i++) {
            let start = i * 500;
            let end = (i+1) * 500;

            let items = node[data_type].slice(start, end);

            let end_text = start + items.length;

            children.push({
              id: 'chunk-' + i,
              name: start + '-' + end_text,
              type: 'chunk',
              children: items,
            });
          }

          this.$refs.tree.addMulti(children, currentPlatformStat, 0);
          currentPlatformStat.open = true;
        }
      }*/
    },
    clearStartDate() {
      this.advanced_search.start_date = null;
      this.showRecords();
    },
  },
  computed: {
    getStartDate() {
      return this.advanced_search.start_date ? moment(this.advanced_search.start_date).format('DD-MM-YYYY') : null;
    },
  },
};
</script>